import React, { Component, createRef, Fragment } from "react";
import {
  Hero,
  Title,
  TechniqueTitle,
  ClientTag,
  CaseWrapper,
  BackButton,
  BackArrow
} from "../styles/Case.styles";

import Reveal from 'react-reveal/Reveal';
import { withRouter } from "react-router";
import Footer from '../components/Footer';
import { Efectr, Efectr1, Efectr2  } from "../styles/effect.styles";

export const ScrollTop = ({ children, location }) => {
  React.useEffect(() => window.scrollTo(0, 0), [location])
  return children
}

class Case extends Component {
  constructor(props) {
    super(props);
    this.introRef = createRef();

    this.state = {
          toBack: false,
          introTop: 0,
          hasBackground: false,
          animateCase: ""
        };
      }
    
      componentDidUpdate() {
        if (this.state.toBack) {
          setTimeout(() => {
            this.props.setNavBackground(false);
            this.props.history.push("/blog");
          }, 400);
        }
        if (this.state.animateCase) {
          setTimeout(() => {
            this.props.setNavBackground(false);
    
            this.props.history.push(this.state.animateCase);
            window.scrollTo(0, 0);
          }, 400);
        }
      }
    
    
      render() {
        return (
          <Fragment>
          <Efectr/>
          <Efectr1/>
          <Efectr2/>
          <ScrollTop>
            <CaseWrapper>
              <Reveal effect="fadeIn">
                <Hero className='mainhero' style={{ backgroundImage: "url('./img/news/WOW12LRG.jpeg')" }}>
                    <div className='herocaption'>
                      <BackButton className='backdetail'
                        onClick={() => this.setState({ toBack: true, hasBackground: false })}
                        toBack={this.state.toBack}
                        hasBackground={this.state.hasBackground}>
                        <BackArrow src="./img/back.png" alt="Back to blog" />
                        <span>Back </span>
                      </BackButton>
                      <div className='container'>
                        <div className='row'>
                          <div className='col-md-12 pl-md-0'>
                            <ClientTag className='date'>October 21, 2024</ClientTag>
                            <Title>Vitamin D</Title>
                            <TechniqueTitle>
                            Called a Vitamin, but acts like a Hormone
                            </TechniqueTitle>
                          </div>
                        </div>
                      </div>
                    </div>
                </Hero>
              </Reveal>
    
              <section className='container' id='detailproject'>
                <div className='row'>
                  <div className='col-md-12'>
                    <p className='content'>You have probably head of vitamin D referred to as the “sunshine vitamin”, but what exactly is it, and why is it so important for your health?</p>
                    <p className='content'>Vitamin D plays a variety of essential roles in the body, from supporting strong bones and healthy teeth to boosting your immune system, enhancing skin health, improving cognition and mood, and even helping to prevent disease. </p>
                     <p className='content'>The way vitamin D is made in your body is pretty amazing—it behaves a lot like a hormone! It all starts when UVB rays from sunlight hit your skin. This energy triggers a form of cholesterol in your skin called 7-dehydrocholesterol to be converted into previtamin D3, which then naturally transforms into vitamin D3 (cholecalciferol) through a heat-driven process. </p>
                     <p className='content'>From here, vitamin D3 travels through your bloodstream to the liver, where an enzyme called 25-hydroxylase converts it into 25-hydroxyvitamin D (calcidiol)—the main circulating form of vitamin D. The final step happens in your kidneys, where 1- alpha-hydroxylase converts calcidiol into 1,25- dihydroxyvitamin D (calcitriol), the active form of vitamin D that delivers all those health benefits. </p>
                     <p className='content'> While sunshine is a natural way to get your dose of vitamin D, you can also find it in various foods and supplements, making sure your body stays powered up with this vital nutrient all year round!</p>

                  
                    <h3 className='my-5'>Tips to Boost Vitamin D</h3>
                    <div>
                      <p className='content'>1. Morning walks: allowing the morning UVB rays to come in contact with you skin will help increase circulating vitamin D levels. </p>
                      <p className='content'>2. Eating High Vitamin D foods: Salmon, tuna, egg yolks, mushrooms, cheeses. </p>
                      <p className='content'>3. Vitamin D fortified foods: Orange juice, milk, cereals, some breads. </p>
                      <p className='content'>4. Supplements: Over the counter supplements, IV infusions, or intra-muscular injections can help boost circulating levels of vitamin D </p>
                      <p className='content'>5. Expert help: Speak with your naturopathic doctor to learn more about how to optimize your individual vitamin D levels! </p>
                    </div>
                  </div>  

                  <div className='col-md-12'></div>
                  <div className='share'>
                    <span className='heading'>
                    Share this blog post :
                    </span>
                    <span className='content'> 
                    <a href="https://www.facebook.com/sharer/sharer.php?u=drmichellemaliknd.com/WOW12" target="_blank" rel="noopener noreferrer">  
                      <i className="fa fa-facebook-f"></i>
                      </a>  
                    </span>
                    <span className='content'> 
                    <a href="https://www.instagram.com/dr.michellemalik.nd" target="_blank" rel="noopener noreferrer">   
                      <i className="fa  fa-instagram"></i>
                      </a>
                    </span>
                  </div>
                </div>
              </section>

            </CaseWrapper>

                      </ScrollTop>
                
                      <Footer />
                
                      </Fragment>
                    );
                  }
                }
                
                export default withRouter(Case);